<template>
  <div :class="data.length == 0 ? 'row m-t-10' : 'row m-t-1'">
    <div class="col-md-12 px-2">
      <div class="bg-white p-3 rounded shade" data-v-step="5" id="db-newstrend">
        <h5 class="no-margin" align="center">News Trend</h5>
        <div class="row p-t-10 p-b-10">
          <div class="col-md-12">
            <loader-component v-if="is_loading" />
            <div v-else>
              <highcharts
                v-if="data && data.length > 0"
                :options="dataBar"
                :ref="'bar_newstrend'"
                :key="barKey"
              />
              <div v-else class="col-md-12 col-sm-12 col-lg-12">
                <div
                  class="alert alert-danger mt-3"
                  id="errorApiEl"
                  role="alert"
                  align="center"
                >
                  <strong>Mohon maaf, data tidak tersedia! </strong> <br />
                  Silahkan lakukan pencarian dengan parameter lain
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row scroll-horizontal p-t-10">
          <div v-for="(newstrend, index) in data" :key="index">
            <news-trend-item-component
              :title="newstrend.title"
              :content="newstrend.content"
              :rank="index + 1"
              :date="newstrend.dates"
              :ids="newstrend.ids"
            />
          </div>
        </div>
      </div>
    </div>
    <modal-dynamic-component
      v-if="currentModal"
      :key="modal_key"
      :modal="currentModal"
      :data="modal_data"
      :static="true"
      :modal_size="modal_size"
    />
  </div>
</template>

<script>
import new_strend_item from "@/views/components/dashboard/new_strend_item.vue";
import loader from "@/views/components/loader.vue";
import modal_newstrend_post from "@/views/components/dashboard/modal_newstrend_post.vue";
import modal_dynamic from "@/views/components/modal_dynamic.vue";
import { Chart } from "highcharts-vue";
import gp from "@/plugins/generalPlugins.js";
import modal_newstrend_chart from "./modal_newstrend_chart.vue";

export default {
  name: "news_trend",
  props: {
    data: {
      default: () => [],
      type: Array,
    },
    barData: Object,
    is_loading: Boolean,
  },
  data() {
    return {
      ids: null,
      modal_key: 0,
      modal_data: [],
      currentModal: null,
      modal_size: "modal-lg",
      dataBar: {},
      barKey: 90,
    };
  },
  components: {
    highcharts: Chart,
    "news-trend-item-component": new_strend_item,
    "modal-dynamic-component": modal_dynamic,
    "loader-component": loader,
  },
  methods: {
    optionsBar: function () {
      let self = this;
      this.dataBar = {
        chart: {
          type: "bar",
          backgroundColor: "transparent",
        },
        title: {
          text: "",
        },
        xAxis: {
          categories: this.barData.dataCategories,
          title: {
            text: null,
          },
        },
        yAxis: {
          min: 0,
          labels: {
            overflow: "justify",
          },
          title: {
            text: "Jumlah Berita",
          },
          stackLabels: {
            enabled: true,
            style: {
              fontWeight: "bold",
              color: "black",
            },
            formatter: function () {
              return gp.thousandSeparator(this.total);
            },
          },
        },
        tooltip: {
          formatter: function () {
            return ` ${this.x} <br> ${
              this.series.name
            } : ${gp.thousandSeparator(this.y)}`;
          },
        },
        plotOptions: {
          series: {
            stacking: "normal",
            cursor: "pointer",
            point: {
              events: {
                click: function (e) {
                  let index = e.point.index;
                  let id_streams = self.data[index].ids;
                  self.viewDataCategory(e, id_streams);
                },
              },
            },
          },
        },
        credits: {
          enabled: false,
        },
        legends: {},
        series: this.barData.dataSeries,
      };
      this.barKey++;
    },
    viewDataCategory: function (self, ids) {
      var view_data = {
        title: self.point.category,
        component: modal_newstrend_chart,
      };
      let dataCategory = [
        {
          idStream: ids,
        },
      ];
      this.currentModal = view_data;
      this.modal_data = dataCategory;
      this.modal_key++;
    },
    viewStream: function (ids, date, judul, content) {
      var view_stream = {
        title: "News Trend",
        subtitle: "news trend pada tanggal " + date[0],
        component: modal_newstrend_post,
      };
      let dataTrend = [
        {
          idTrend: ids[0],
          date: date,
          ids: ids,
          judul: judul,
          content: content,
        },
      ];
      this.currentModal = view_stream;
      this.modal_data = dataTrend;
      this.modal_key++;
    },
  },
  mounted: function () {
    if (this.data) {
      this.optionsBar();
    }
  },
};
</script>
<style scoped>
.scroll-horizontal {
  align-items: stretch;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  overflow-x: auto;
}
</style>